import Api from './api';

export const getAllTicketsForUnification = async (requestUser, id, title, idsException) => { 
  let data = []
  await Api.get(`/calleds-unification?id=${id}&requestUser=${requestUser}&title=${title}&idsException=${idsException}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const unificationTickets = async (payload) => { 
  let data = []
  await Api.post(`/calleds-unification`, payload)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getCalledInfo = async (calledid) => { 
  let data = []
  await Api.get(`/calleds/calledInfoPaginate/${calledid}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};